export enum InternalApprovalStatus {
    Pending = 'pending',
    Approved = 'approved',
    Clarification = 'clarification',
    RequestChanges = 'requestChanges',
    Rejected = 'rejected',
}

export enum ProjectStageApprovalStatus {
}
  